// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var TemplateType_Enum;
(function (TemplateType_Enum) {
    TemplateType_Enum["UNKNOWN"] = "UNKNOWN";
    TemplateType_Enum["TEMPLATE"] = "TEMPLATE";
    TemplateType_Enum["DRAFT"] = "DRAFT";
    TemplateType_Enum["SENT"] = "SENT";
    TemplateType_Enum["SYSTEM"] = "SYSTEM";
    TemplateType_Enum["SCHEDULED"] = "SCHEDULED";
})(TemplateType_Enum || (TemplateType_Enum = {}));
export var TemplateType_Enum_index;
(function (TemplateType_Enum_index) {
    TemplateType_Enum_index[TemplateType_Enum_index["UNKNOWN"] = 0] = "UNKNOWN";
    TemplateType_Enum_index[TemplateType_Enum_index["TEMPLATE"] = 1] = "TEMPLATE";
    TemplateType_Enum_index[TemplateType_Enum_index["DRAFT"] = 2] = "DRAFT";
    TemplateType_Enum_index[TemplateType_Enum_index["SENT"] = 3] = "SENT";
    TemplateType_Enum_index[TemplateType_Enum_index["SYSTEM"] = 4] = "SYSTEM";
    TemplateType_Enum_index[TemplateType_Enum_index["SCHEDULED"] = 5] = "SCHEDULED";
})(TemplateType_Enum_index || (TemplateType_Enum_index = {}));
export const EmailTemplatesApi = {
    ListTemplates(fn, req) {
        return fn(`/massemail/templates/v1/templates?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetTemplate(fn, req) {
        try {
            fm.validateUrlParam(req["templateId"], "templateId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/massemail/templates/v1/templates/${req["templateId"]}?${fm.renderURLSearchParams(req, ["templateId"])}`, { method: "GET" });
    },
    UpdateTemplate(fn, req) {
        return fn(`/massemail/templates/v1/templates`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteTemplate(fn, req) {
        try {
            fm.validateUrlParam(req["templateId"], "templateId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/massemail/templates/v1/templates/${req["templateId"]}?${fm.renderURLSearchParams(req, ["templateId"])}`, { method: "DELETE" });
    },
    RenderTemplate(fn, req) {
        return fn(`/massemail/templates/v1/templates/render`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetSettings(fn, req) {
        return fn(`/massemail/templates/v1/settings?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    UpdateSettings(fn, req) {
        return fn(`/massemail/templates/v1/settings`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    ListMedia(fn, req) {
        return fn(`/massemail/templates/v1/media?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
